import { joinParts } from '../utils'

export const transaction = {
  data: (cod: string) => joinParts('transactions', cod),
}
